/* BUSCADOR QUE PERDONA  ·  DAR, 3-sep-2026  ·  rehecho 13-oct-2026

   El buscador de Shopify tiene dos caras y ninguna sirve sola:

   - Texto libre ("bills envio express"): perdona dedazos, pero devuelve casi
     el catalogo entero (chivas: 977 de 1308). Lo bueno sale arriba y el resto
     es relleno.
   - Por campo (tag:x OR title:x): devuelve justo lo que es, pero no perdona
     nada. Antes se mandaba la frase ENTERA como una sola etiqueta, y bastaba
     una palabra de mas o un dedazo para que no saliera nada. Asi se perdio el
     Buffalo Bills express: "Bills envio express" si salia, "Bufalo envio
     express" o "Buffalo azul express" no.

   Ahora cada palabra se interpreta por separado y se exige que TODAS esten en
   las etiquetas o en el titulo del producto (en cualquiera de los dos):

   1. Se quitan las palabras que no buscan nada: jersey, de, la, envio...
   2. Las frases y palabras con significado propio se vuelven filtro:
      "envio express" -> express, "nino"/"kids" -> nino, "dama" -> mujer,
      "hombre" -> que no sea de mujer ni de nino, colores, local, visita...
   3. Los apodos y nombres en espanol se suman a la palabra: "bufalo" busca
      tambien buffalo, "vaqueros" tambien cowboys, "aguilas" tambien america.
   4. Si la palabra no existe en el catalogo, se completa ("chiv" -> chivas) o
      se corrige por distancia de edicion ("bils" -> bills). La correccion SE
      AVISA en pantalla: callarla hace creer que la tienda no tiene lo pedido.
   5. Las palabras de categoria (futbol, nfl, seleccion...) solo cuentan si no
      hay un equipo o jugador: "seleccion argentina" busca argentina, porque
      no todos los jerseys de Argentina traen la etiqueta Selecciones.

   Si aun asi no sale nada, la pagina de resultados cae al texto libre y lo
   dice: "Lo mas parecido a...". Nunca se deja al cliente en un callejon.

   El vocabulario sale de las etiquetas REALES de la tienda (cj-dicc, en vivo)
   mas las palabras que solo viven en los titulos (lista de abajo).
*/

(function () {
  if (window.__cjBuscador) return;
  window.__cjBuscador = true;

  var N = function (s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  };

  function palabras(s) {
    return N(s).split(/[^a-z0-9]+/).filter(Boolean);
  }

  function conjunto(texto) {
    var o = {};
    texto.split(' ').forEach(function (p) { if (p) o[p] = true; });
    return o;
  }

  /* Palabras que no buscan nada. "envio" y "entrega" estan aqui porque la
     frase "envio express" ya se convirtio en filtro antes de llegar. */
  var VACIAS = conjunto(
    'jersey jerseys jersy jersei jerseis yersey camiseta camisetas playera playeras ' +
    'uniforme uniformes casaca casacas remera remeras de del la las el los lo en con ' +
    'para por y e o u a al un una unos unas the of and or not no talla tallas ' +
    'original originales oficial oficiales nuevo nuevos nuevas envio envios entrega ' +
    'entregas quiero busco buscar tienen tienes hay venden me mi club equipo equipos ' +
    'deporte deportes modelo version temporada jugador aficionado fan camisa camisas'
  );

  /* Frases que se leen juntas. Se aplican al texto ya sin acentos. */
  var FRASES = [
    [/\b(envio|envios|entrega|entregas)\s+(express|expres|xpress|rapido|rapida|inmediato|inmediata|urgente)\b/g, 'express'],
    [/\bfutbol\s+americano\b/g, 'americano'],
    [/\bnueva\s+york\b/g, 'new york'],
    [/\bnueva\s+orleans\b/g, 'new orleans'],
    [/\bnueva\s+inglaterra\b/g, 'patriots'],
    [/\bmedias\s+rojas\b/g, 'red sox'],
    [/\bmedias\s+blancas\b/g, 'white sox'],
    [/\bhalcones\s+marinos\b/g, 'seahawks'],
    [/\bmanga\s+corta\b/g, '']
  ];

  /* Filtros y categorias. "t": lo que se busca. "no": lo que se excluye.
     tipo 'cat' = categoria, se descarta si hay un equipo o jugador. */
  var CONCEPTOS = {
    express: { t: ['express'] },
    mujer: { t: ['mujer'] },
    nino: { t: ['nino'], ver: 'niño' },
    hombre: { t: [], no: ['mujer', 'nino'] },
    local: { t: ['local'] },
    visita: { t: ['visita', 'visitante'] },
    alternativa: { t: ['alternativa'] },
    retro: { t: ['retro', 'clasica'] },
    azul: { t: ['azul', 'azules'] },
    blanco: { t: ['blanco', 'blanca', 'blancas', 'blancos'] },
    negro: { t: ['negro', 'negra', 'negros', 'negras'] },
    rojo: { t: ['rojo', 'roja', 'rojos', 'rojas'] },
    verde: { t: ['verde'] },
    militar: { t: ['militar', 'camuflaje'] },
    gris: { t: ['gris'] },
    naranja: { t: ['naranja'] },
    morado: { t: ['morado', 'morada'] },
    celeste: { t: ['celeste'] },
    rosa: { t: ['rosa', 'rosado', 'rosada'] },
    amarillo: { t: ['amarillo', 'amarilla'] },
    dorado: { t: ['dorado', 'dorada'] },
    guinda: { t: ['guinda'] },
    futbol: { t: ['futbol', 'soccer'], no: ['americano'], tipo: 'cat' },
    americano: { t: ['nfl', 'americano', 'football'], tipo: 'cat' },
    nba: { t: ['nba'], tipo: 'cat' },
    mlb: { t: ['mlb', 'baseball'], tipo: 'cat' },
    seleccion: { t: ['selecciones', 'seleccion', 'mundial'], tipo: 'cat' },
    liga: { t: ['liga'], tipo: 'cat' },
    mx: { t: ['mx'], tipo: 'cat' },
    premier: { t: ['premier'], tipo: 'cat' },
    league: { t: ['league'], tipo: 'cat' },
    bundesliga: { t: ['bundesliga'], tipo: 'cat' },
    serie: { t: ['serie'], tipo: 'cat' },
    ligue: { t: ['ligue'], tipo: 'cat' },
    mls: { t: ['mls'], tipo: 'cat' },
    eredevise: { t: ['eredevise'], tipo: 'cat' },
    primeira: { t: ['primeira'], tipo: 'cat' },
    brasileirao: { t: ['brasileirao'], tipo: 'cat' },
    ligas: { t: ['ligas'], tipo: 'cat' }
  };

  var A_CONCEPTO = {};
  function concepto(clave, lista) {
    lista.split(' ').forEach(function (p) { A_CONCEPTO[p] = clave; });
  }
  concepto('express', 'express expres xpress rapido rapida inmediato inmediata urgente');
  concepto('mujer', 'mujer mujeres dama damas femenino femenina chica chicas');
  concepto('nino', 'nino ninos nina ninas nene nenes infantil kids kid chico chicos juvenil youth bebe');
  concepto('hombre', 'hombre hombres caballero caballeros adulto adultos varon');
  concepto('local', 'local casa home titular');
  concepto('visita', 'visita visitante away');
  concepto('alternativa', 'alternativa alternativo tercera tercer');
  concepto('retro', 'retro clasica clasico vintage antigua antiguo leyenda leyendas');
  concepto('azul', 'azul azules');
  concepto('blanco', 'blanco blanca blancos blancas');
  concepto('negro', 'negro negra negros negras');
  concepto('rojo', 'rojo roja rojos rojas');
  concepto('verde', 'verde');
  concepto('militar', 'militar camuflaje camuflado');
  concepto('gris', 'gris');
  concepto('naranja', 'naranja');
  concepto('morado', 'morado morada');
  concepto('celeste', 'celeste');
  concepto('rosa', 'rosa rosado rosada');
  concepto('amarillo', 'amarillo amarilla');
  concepto('dorado', 'dorado dorada');
  concepto('guinda', 'guinda');
  concepto('futbol', 'futbol fut soccer');
  concepto('americano', 'americano nfl football');
  concepto('nba', 'nba basquetbol basquet basket basketball baloncesto basquebol');
  concepto('mlb', 'mlb beisbol baseball beis');
  concepto('seleccion', 'seleccion selecciones mundial mundialista');
  concepto('liga', 'liga laliga');
  concepto('mx', 'mx');
  concepto('premier', 'premier');
  concepto('league', 'league');
  concepto('bundesliga', 'bundesliga');
  concepto('serie', 'serie');
  concepto('ligue', 'ligue');
  concepto('mls', 'mls');
  concepto('eredevise', 'eredevise eredivisie');
  concepto('primeira', 'primeira');
  concepto('brasileirao', 'brasileirao');
  concepto('ligas', 'ligas');

  /* La palabra se CAMBIA por otra(s): apodos que no comparten ninguna palabra
     con el nombre real. */
  var ALIAS = {
    merengue: 'real madrid', merengues: 'real madrid',
    manu: 'manchester united', citizens: 'manchester city',
    maquina: 'cruz azul', cementeros: 'cruz azul', cruzazul: 'cruz azul',
    nerazzurri: 'inter milan',
    holanda: 'paises bajos', netherlands: 'paises bajos'
  };

  /* La palabra se queda y se SUMAN estas: nombres en espanol, apodos y
     plurales. "aguilas" busca aguilas (Eagles) y america. */
  var SUMA = {};
  function suma(lista, extra) {
    lista.split(' ').forEach(function (p) { SUMA[p] = extra.split(' '); });
  }
  // Liga MX
  suma('aguilas aguila americanista ame', 'america');
  suma('chiva chivitas rebano tapatios', 'chivas');
  suma('pandilla', 'rayados');
  suma('felinos uanl tigre', 'tigres');
  suma('unam auriazules', 'pumas');
  suma('diablos', 'toluca');
  suma('tuzos', 'pachuca');
  suma('rayos', 'necaxa');
  suma('zorros', 'atlas');
  suma('gallos', 'queretaro');
  suma('camoteros franja', 'puebla');
  suma('esmeraldas fieras', 'leon');
  suma('bravos', 'braves juarez');
  suma('potros', 'colts atlante');
  // Europa
  suma('barsa barca culer cules blaugrana', 'barcelona');
  suma('atleti colchoneros', 'atletico');
  suma('juve', 'juventus');
  suma('rossoneri', 'milan');
  suma('napoli', 'napoles');
  suma('marseille', 'marsella');
  suma('reds', 'liverpool');
  suma('gunners', 'arsenal');
  suma('blues', 'chelsea');
  suma('spurs', 'tottenham');
  suma('toffees', 'everton');
  suma('parisino', 'paris psg');
  // Selecciones
  suma('tri trico mexicana mexicano', 'mexico');
  suma('albiceleste', 'argentina');
  suma('brazil canarinha', 'brasil');
  suma('germany', 'alemania');
  suma('spain', 'espana');
  suma('france', 'francia');
  suma('england', 'inglaterra');
  suma('japan', 'japon');
  suma('italy', 'italia');
  suma('korea', 'corea');
  suma('usa eeuu eua gringos', 'usa unidos');
  // NFL en espanol
  suma('bufalo bufalos bufallo', 'buffalo');
  suma('vaqueros', 'cowboys');
  suma('acereros', 'steelers');
  suma('empacadores', 'packers');
  suma('cuervos', 'ravens');
  suma('delfines', 'dolphins');
  suma('patriotas', 'patriots');
  suma('gigantes', 'giants');
  suma('halcones', 'falcons');
  suma('jefes', 'chiefs');
  suma('osos', 'bears');
  suma('leones', 'lions');
  suma('vikingos', 'vikings');
  suma('carneros', 'rams');
  suma('cargadores', 'chargers');
  suma('titanes', 'titans');
  suma('texanos', 'texans');
  suma('jaguares', 'jaguars');
  suma('cafes', 'browns');
  suma('bengalies bengalis', 'bengals');
  suma('cardenales', 'cardinals');
  suma('bucaneros bucs', 'buccaneers');
  suma('comandantes', 'commanders');
  suma('panteras', 'panthers');
  suma('malosos incursores', 'raiders');
  suma('filadelfia', 'philadelphia');
  suma('pitsburgo pittsburg pitsburg', 'pittsburgh');
  suma('niners gambusinos', '49ers');
  // NBA
  suma('toros', 'bulls');
  suma('celtas', 'celtics');
  suma('guerreros', 'warriors');
  suma('calor', 'heat');
  suma('espuelas', 'spurs');
  suma('cohetes', 'rockets');
  suma('magia', 'magic');
  suma('soles', 'suns');
  suma('reyes', 'kings');
  suma('redes', 'nets');
  suma('pistones', 'pistons');
  suma('kobe mamba', 'lakers');
  suma('cavs', 'cavaliers');
  suma('sixers', '76ers');
  suma('mavs', 'mavericks');
  suma('wolves', 'timberwolves');
  // MLB
  suma('yankis yanquis yanqui yankee', 'yankees');
  suma('dodger', 'dodgers');
  suma('cachorros', 'cubs');
  suma('piratas', 'pirates');
  suma('marineros', 'mariners');
  suma('azulejos', 'jays');
  suma('filis phillis', 'phillies');
  suma('nacionales', 'nationals');
  suma('cerveceros', 'brewers');
  suma('reales', 'royals');
  suma('mellizos', 'twins');
  suma('guardianes', 'guardians');
  suma('atleticos', 'athletics');
  suma('angelinos', 'angels');
  // Jugadores
  suma('cr7 bicho siu siuu siuuu', 'cristiano ronaldo');
  suma('pulga goat lionel', 'messi');
  suma('kylian', 'mbappe');
  suma('ney', 'neymar');
  suma('dinho', 'ronaldinho');
  suma('wemby', 'wembanyama');
  suma('luka', 'doncic');
  suma('giannis', 'antetokounmpo');
  suma('steph', 'curry');
  suma('lebron bron', 'lebron james');

  /* Palabras que solo viven en los titulos (abreviaturas, colores, modelos).
     Sacadas del catalogo el 13-oct-2026. Las etiquetas NO van aqui: esas
     llegan en vivo desde la tienda. */
  var TITULOS = (
    '90s acm aja ale alg alternativa amarillo ame aniversario aqua arg ari ars asl asm ate ath ' +
    'atl atm ats aus aut avl azules bal bancomer bar bel bet bha bih bkn blanca blancas boc bos ' +
    'bra braut buf bvb cafe campos can car caz cel celeste cha chc che chi cin civ clasica cle ' +
    'cod col connect cor cpv cro cuw cws cze dal debut den det egy eng entrenamiento esp eve ' +
    'fcb fcj fcp fey fio fla fra gb gen ger gha gris gsw gua guinda hai hou ind int irn irq ita ' +
    'jax jor jpn juv kc kor ksa laa lac lad lal lar laz leo lev liv lv mangas mar mci mem mex mia ' +
    'mil militar min modric morado mty mun nap naranja nas ne nec ned negra negro nintendo nop nor ' +
    'nyg nyj nyk nym nyy nzl okc ol oly om orl osa oscuro osu pac pal pan phi phx pit por pue pum ' +
    'qat qro rbl riv rma roja rojo rom ronaldhino rosa rsa rso sac sas sco scp sd sea sen sev sf ' +
    'sla slb space spiderman stl sui swe tb teka ten tex tig tij tol tor tot tun tur uru uta uzb ' +
    'val vfb vil was whu wsh xol'
  ).split(' ');

  var ETIQUETAS = (function () {
    var el = document.getElementById('CjDicc');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  })();

  var VOCAB = {};
  ETIQUETAS.forEach(function (t) {
    if (/^par-\d/i.test(t)) return;
    palabras(t).forEach(function (p) { VOCAB[p] = true; });
  });
  TITULOS.forEach(function (p) { VOCAB[p] = true; });
  Object.keys(CONCEPTOS).forEach(function (k) {
    CONCEPTOS[k].t.forEach(function (p) { VOCAB[p] = true; });
  });
  // Sin etiquetas de la tienda no hay con que corregir: se busca tal cual
  var CON_VOCAB = ETIQUETAS.length > 50;
  // Para completar y corregir: solo palabras de 4+ letras, sin numeros puros
  var LISTA = Object.keys(VOCAB).filter(function (p) {
    return p.length >= 4 && !/^\d+$/.test(p);
  });

  // Distancia de edicion, palabra contra palabra
  function distancia(a, b) {
    if (a === b) return 0;
    if (!a.length || !b.length) return (a.length || b.length);
    var fila = [], i, j;
    for (j = 0; j <= b.length; j++) fila[j] = j;
    for (i = 1; i <= a.length; i++) {
      var ant = fila[0];
      fila[0] = i;
      for (j = 1; j <= b.length; j++) {
        var tmp = fila[j];
        fila[j] = Math.min(
          fila[j] + 1,
          fila[j - 1] + 1,
          ant + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1)
        );
        ant = tmp;
      }
    }
    return fila[b.length];
  }

  /* Tolerancia por largo: en una palabra corta un solo cambio ya la convierte
     en otra distinta ("bills" y "bulls"), en una larga no. */
  function tolerancia(n) {
    if (n <= 4) return 1;
    if (n <= 7) return 2;
    return 3;
  }

  /* Palabra que no esta en el catalogo: primero se completa ("chiv" ->
     chivas), despues se corrige ("bils" -> bills). Con la misma distancia
     entran todas las empatadas, hasta cuatro. */
  function parecidas(p) {
    var r = { completa: [], corrige: [] };
    if (p.length < 3) return r;
    LISTA.forEach(function (v) {
      if (v.length > p.length && v.indexOf(p) === 0) r.completa.push(v);
    });
    r.completa.sort(function (a, b) { return a.length - b.length; });
    r.completa = r.completa.slice(0, 4);
    if (r.completa.length && p.length < 5) return r;

    var tol = tolerancia(p.length), mejor = 99, lista = [];
    LISTA.forEach(function (v) {
      if (Math.abs(v.length - p.length) > tol) return;
      var d = distancia(p, v);
      if (d > tol || d > mejor) return;
      // Un dedazo casi nunca cambia la primera letra
      if (d > 1 && v.charAt(0) !== p.charAt(0)) return;
      if (d < mejor) { mejor = d; lista = []; }
      lista.push(v);
    });
    r.corrige = lista.slice(0, 4);
    return r;
  }

  function grupoSQL(g) {
    var partes = g.t.map(function (p) { return 'tag:' + p + ' OR title:' + p; });
    return '(' + partes.join(' OR ') + ')';
  }

  /* Texto del cliente -> consulta por campo.
     Devuelve { consulta, correcciones: [[dijo, buscamos]], ignoradas } */
  function armar(texto) {
    var limpio = N(texto);
    FRASES.forEach(function (f) { limpio = limpio.replace(f[0], f[1]); });

    var grupos = [], vistos = {}, correcciones = [], ignoradas = [], dudosas = [];
    var hayEntidad = false;

    function agregar(g) {
      g.t = g.t.filter(function (p, i) { return g.t.indexOf(p) === i; });
      var llave = g.t.join('|') + '!' + (g.no || []).join('|');
      if (vistos[llave]) return;
      vistos[llave] = true;
      grupos.push(g);
    }

    function entidad(p, desdeAlias) {
      if (!desdeAlias && ALIAS[p]) {
        palabras(ALIAS[p]).forEach(function (q) {
          if (!VACIAS[q]) entidad(q, true);
        });
        return;
      }
      var t = [p];
      if (SUMA[p]) t = t.concat(SUMA[p]);
      if (!CON_VOCAB || VOCAB[p] || SUMA[p] || /^\d+$/.test(p)) {
        agregar({ t: t, tipo: /^\d+$/.test(p) ? 'filtro' : 'ent' });
        if (!/^\d+$/.test(p)) hayEntidad = true;
        return;
      }
      var par = parecidas(p);
      var extra = par.completa.concat(par.corrige.filter(function (v) {
        return par.completa.indexOf(v) === -1;
      }));
      if (extra.length) {
        if (par.corrige.length && !par.completa.length) correcciones.push([p, par.corrige[0]]);
        agregar({ t: extra.concat([p]), tipo: 'ent' });
        hayEntidad = true;
        return;
      }
      dudosas.push(p);
    }

    palabras(limpio).forEach(function (p) {
      if (VACIAS[p]) { ignoradas.push(p); return; }
      var c = A_CONCEPTO[p];
      if (c) {
        var def = CONCEPTOS[c];
        agregar({ t: def.t, no: def.no, tipo: def.tipo || 'filtro', clave: c });
        return;
      }
      entidad(p, false);
    });

    // Lo que no se reconoce solo se busca si es lo UNICO que escribio
    if (grupos.length) {
      ignoradas = ignoradas.concat(dudosas);
    } else {
      dudosas.forEach(function (p) { agregar({ t: [p], tipo: 'ent' }); hayEntidad = true; });
    }

    // Con equipo o jugador, la categoria sobra (y estorba)
    if (hayEntidad) {
      grupos = grupos.filter(function (g) { return g.tipo !== 'cat'; });
    }

    var si = grupos.filter(function (g) { return g.t.length; });
    if (!si.length) return { consulta: '', correcciones: correcciones, ignoradas: ignoradas };

    var piezas = si.map(grupoSQL);
    grupos.forEach(function (g) {
      (g.no || []).forEach(function (p) {
        piezas.push('NOT tag:' + p);
        piezas.push('NOT title:' + p);
      });
    });
    return { consulta: piezas.join(' AND '), correcciones: correcciones, ignoradas: ignoradas };
  }

  /* A donde manda "Buscar". q lleva la consulta armada y t lo que escribio
     el cliente, para enseñarselo tal cual en la pagina de resultados. */
  function url(texto) {
    var v = (texto || '').trim();
    var e = encodeURIComponent;
    // Si ya trae ":" es que alguien escribio su propia consulta
    if (v.indexOf(':') > -1) return '/search?type=product&q=' + e(v);
    var a = armar(v);
    if (a.consulta) return '/search?type=product&q=' + e(a.consulta) + '&t=' + e(v);
    return '/search?type=product&amplia=1&q=' + e(v) + '&t=' + e(v);
  }

  window.CJBusca = { armar: armar, url: url, normaliza: N };

  function pedir(q) {
    var u = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
    return fetch(u).then(function (r) { return r.json(); }).then(function (d) {
      try { return d.resources.results.products || []; } catch (e) { return []; }
    });
  }

  function dinero(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* El titulo y la URL vienen del catalogo, no de un desconocido, pero igual
     se escapan: el dia que alguien pegue un ' o un & en el nombre de un
     producto, la lista se rompe callada y nadie sabe por que. */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function aviso(correcciones) {
    if (!correcciones.length) return '';
    return 'Buscamos ' + correcciones.map(function (c) {
      return '<strong>' + esc(c[1]) + '</strong> en vez de «' + esc(c[0]) + '»';
    }).join(', ');
  }

  function pintar(caja, productos, armado, consulta, parecido) {
    if (!productos.length) {
      caja.innerHTML = '<p class="cj-bus-vacio">No encontramos <strong>' +
        esc(consulta) + '</strong>.<br>Prueba con el equipo: Chivas, Barcelona, Lakers…</p>';
      return;
    }

    var html = '';
    if (parecido) {
      html += '<p class="cj-bus-aviso">No hay nada exacto para <strong>' + esc(consulta) +
        '</strong>. Esto es lo más parecido:</p>';
    } else if (armado.correcciones.length) {
      // Se DICE que se corrigio: callarlo hace creer que no hay lo que pidio
      html += '<p class="cj-bus-aviso">' + aviso(armado.correcciones) + '</p>';
    }

    html += '<ul class="cj-bus-lista">';
    productos.forEach(function (p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
      html += '<li><a href="' + esc(p.url) + '">' +
        (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="48" height="48">' : '<span class="cj-bus-sinfoto"></span>') +
        '<span class="cj-bus-txt">' +
        '<span class="cj-bus-nombre">' + esc(p.title) + '</span>' +
        '<span class="cj-bus-precio">' + dinero(p.price) + (p.available ? '' : ' · agotado') + '</span>' +
        '</span></a></li>';
    });
    html += '</ul>';
    html += '<a class="cj-bus-todo" href="' + esc(url(consulta)) + '">Ver todos los resultados</a>';
    caja.innerHTML = html;
  }

  function conectar(campo, caja) {
    var reloj = null;
    var ultima = '';

    campo.addEventListener('input', function () {
      var q = campo.value.trim();
      clearTimeout(reloj);
      if (q.length < 2) { caja.innerHTML = ''; caja.hidden = true; ultima = ''; return; }

      // se espera a que deje de teclear: una peticion por letra revienta el limite
      reloj = setTimeout(function () {
        if (q === ultima) return;
        ultima = q;
        caja.hidden = false;
        caja.innerHTML = '<p class="cj-bus-cargando">Buscando…</p>';

        var a = armar(q);
        var exacta = a.consulta ? pedir(a.consulta) : Promise.resolve([]);
        exacta.then(function (productos) {
          if (q !== ultima) return;
          if (productos.length) return pintar(caja, productos, a, q, false);
          // nada exacto: el texto libre de Shopify perdona mas
          return pedir(q).then(function (p2) {
            if (q !== ultima) return;
            pintar(caja, p2, a, q, p2.length > 0);
          });
        }).catch(function () {
          caja.innerHTML = '<p class="cj-bus-vacio">No se pudo buscar. Intenta de nuevo.</p>';
        });
      }, 260);
    });
  }

  function arrancar() {
    document.querySelectorAll('[data-cj-bus]').forEach(function (raiz) {
      // Marca PROPIA: el panel usa dataset.listo para su abrir/cerrar, y con
      // la misma llave el motor creia que ya estaba conectado y no hacia nada.
      if (raiz.dataset.busListo) return;
      raiz.dataset.busListo = '1';
      var campo = raiz.querySelector('input[type="search"], input[name="q"]');
      var caja = raiz.querySelector('[data-cj-bus-resultados]');
      if (campo && caja) conectar(campo, caja);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();

  // Para probar la logica sin navegador
  window.__cjBusDebug = { armar: armar, parecidas: parecidas, distancia: distancia, vocab: VOCAB };
})();
